import React, { useRef, useEffect } from 'react';
import { useUpdateEffect } from 'ahooks';
import Label from './Label';
import { registerEventGeometry } from '../events';
import useProps from '../_util/useProps';

export default function(props) {
    const { data, property, style, text } = props;
    const featureRef = useRef();
    const { featureLayer } = useProps();

    useEffect(() => {
        let feature = new Label({
            geometry: data,
            style,
            properties: property,
            text,
        });

        // 注册事件
        registerEventGeometry(feature, props);

        featureLayer.entities.add(feature);

        featureRef.current = feature;

        return () => {
            featureLayer.entities.remove(feature);
        };
    }, []);

    useUpdateEffect(() => {
        featureRef.current.setGeometry(data);
    }, [data]);

    useUpdateEffect(() => {
        featureRef.current.setProperties(property);
    }, [property]);

    useUpdateEffect(() => {
        // featureRef.current.setStyle(style);
    }, [style]);

    return <></>;
}
